const queryString = window.location.search;
const domain = "https://city-chain-sso-118818c00dc7f74049f0.o2.myshopify.dev";
if (queryString) {
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.get('checkout_url')) {
    window.location.href = domain + "/home/bf3bbb-2f?return=/checkout"
  } else {
    window.location.href = domain + "/home/bf3bbb-2f"
  }
} else {
  window.location.href = domain + "/home/bf3bbb-2f"
}